import { SvgIcon } from "@mui/material";

const ContinueIcon = () => {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 24C18.6273 24 24 18.6273 24 12C24 5.37272 18.6273 0 12 0C5.37272 0 0 5.37272 0 12C0 18.6273 5.37272 24 12 24ZM12 2.00002C17.5227 2.00002 22 6.47728 22 12C22 17.5227 17.5227 22 12 22C6.47728 22 2.00002 17.5227 2.00002 12C2.00002 6.47728 6.47728 2.00002 12 2.00002Z"
        fill="#4F4F4F"
      />
      <path
        d="M13.2929 17.7071C13.6834 18.0976 14.3166 18.0976 14.7071 17.7071C15.0976 17.3166 15.0976 16.6834 14.7071 16.2929L10.4142 12L14.7071 7.70709C15.0976 7.31657 15.0976 6.68338 14.7071 6.29287C14.3166 5.90235 13.6834 5.90235 13.2929 6.29287L8.29288 11.2929C7.90236 11.6834 7.90236 12.3166 8.29288 12.7071L13.2929 17.7071Z"
        fill="#4F4F4F"
      />
    </SvgIcon>
  );
};

export default ContinueIcon;
